import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { center } from '@turf/turf';
import mapboxgl from 'mapbox-gl';
import ReactDOM from 'react-dom/client';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import {
  $investProDistricts,
  $showHeatmap,
  changePopupDataEv,
} from '../../../models/investProModel/index.js';
import { $gradientBucketsDist } from '../../../models/gradientModel/index.js';
import { formDynamicBuckets } from '../../../utils/hexagon-utils.js';
import DotPopup from '../../MapPopups/DotPopup/DotPopup.jsx';
import { changeLayerVisibility } from '../../../utils/mapbox-utils.js';

const onClick = (e) => {
  if (window.map.getZoom() <= 6 || window.map.getZoom() > 11) return;
  const dotsLayers = window.map
    .getStyle()
    .layers.map((item) => item.id)
    .filter((item) => {
      return (
        item.startsWith('invest_pro_dots_') ||
        item.startsWith('invest_pro_cluster_')
      );
    });
  const features = window.map.queryRenderedFeatures(e.point, {
    layers: [
      ...dotsLayers,
      'invest_pro_districts_layer',
      'invest_pro_minres_layer',
    ],
  });
  if (features[0].layer.id !== 'invest_pro_districts_layer') return;
  const feature = e.features[0];
  const poly_center = center(feature);
  const { coordinates } = poly_center.geometry;
  changePopupDataEv(feature);

  // if (window.dotPopups && window.dotPopups.length > 0) {
  //   if (
  //     window.dotPopups.find(
  //       (item) => item.options.id === feature.properties.code
  //     )
  //   )
  //     return;
  // }
  //
  // const newPopup = new mapboxgl.Popup({
  //   closeOnClick: false,
  //   closeButton: false,
  //   id: feature.properties.code,
  // })
  //   .setLngLat(coordinates)
  //   .setHTML('')
  //   .addTo(window.map);
  //
  // if (!window.dotPopups) {
  //   window.dotPopups = [newPopup];
  // } else {
  //   if (window.dotPopups.length === 1) {
  //     const first = window.dotPopups.shift();
  //     first.remove();
  //   }
  //   window.dotPopups.push(newPopup);
  // }
  //
  // const popups = Array.from(
  //   document.getElementsByClassName('mapboxgl-popup-content')
  // );
  // popups.forEach((popup) => {
  //   if (popup.childNodes.length === 0)
  //     ReactDOM.createRoot(popup).render(
  //       <DotPopup feature={feature} instance={newPopup} />
  //     );
  // });
};

function InvestProDistricts() {
  const mapLoaded = useUnit($mapLoaded);
  const polygons = useUnit($investProDistricts);
  const { buckets, colors } = useUnit($gradientBucketsDist);
  const showHeatmap = useUnit($showHeatmap);

  const createLayer = (update) => {
    const investProAdminData = {
      type: 'FeatureCollection',
      features: polygons,
    };

    const gradientProp = formDynamicBuckets(buckets, colors, 'index');

    if (update) {
      window.map
        .getSource('invest_pro_districts_source')
        .setData(investProAdminData);
      window.map.setPaintProperty(
        'invest_pro_districts_layer',
        'fill-color',
        gradientProp
      );
    } else {
      if (!window.map.getSource('invest_pro_districts_source')) {
        window.map.addSource('invest_pro_districts_source', {
          type: 'geojson',
          data: investProAdminData,
        });
      }

      if (!window.map.getLayer('invest_pro_districts_layer')) {
        window.map.addLayer({
          id: 'invest_pro_districts_layer',
          type: 'fill',
          source: 'invest_pro_districts_source',
          paint: {
            'fill-color': gradientProp,
            'fill-opacity': [
              'interpolate',
              ['linear'],
              ['zoom'],
              6,
              0,
              7,
              0.8,
              11,
              0.1,
            ],
            'fill-outline-color': '#000000',
          },
        });

        window.map.on('click', 'invest_pro_districts_layer', onClick);

        window.map.on('mouseenter', 'invest_pro_districts_layer', () => {
          window.map.getCanvas().style.cursor = 'pointer';
        });

        window.map.on('mouseleave', 'invest_pro_districts_layer', () => {
          window.map.getCanvas().style.cursor = '';
        });
      }
    }
  };

  useEffect(() => {
    if (mapLoaded && polygons) {
      if (window.map.getLayer('invest_pro_districts_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, polygons, buckets]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('invest_pro_districts_layer')) {
      if (showHeatmap) {
        changeLayerVisibility('invest_pro_districts_layer', false);
      } else {
        changeLayerVisibility('invest_pro_districts_layer', true);
      }
    }
  }, [showHeatmap]);

  return null;
}

export default InvestProDistricts;
